module.exports = __webpack_public_path__ + "img/mediaBg.55a8a5a6.png";